import graphqlClient from '~/graphql/graphqlClient';

export interface MutationDowngradeAbilityArgs {
  playerId: string;
  heroHandle: string;
  abilityHandle: string;
  heroBuildId: string;
}

export interface AbilityChangeResult {
  heroHandle: string;
  heroBuild: any;
}

const mutation = `
mutation DowngradeAbility(
  $playerId: String!
  $heroHandle: String!
  $abilityHandle: String!
  $heroBuildId: String!
) {
  downgradeAbility(
    playerId: $playerId
    heroHandle: $heroHandle
    abilityHandle: $abilityHandle
    heroBuildId: $heroBuildId
  ) {
    heroHandle
    heroBuild
  }
}`;

export default async function mutationDowngradeAbility(args: MutationDowngradeAbilityArgs) {
  return await graphqlClient.request<AbilityChangeResult>('downgradeAbility', mutation, args);
}
